import { useTranslation } from "react-i18next";
import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";

export default function TermsPage() {
  const { t } = useTranslation();

  return (
    <div className="min-h-screen bg-background-50">
      <Navbar />
      <div className="pt-28 md:pt-32 pb-16">
        <div className="w-full px-4 md:px-6 lg:px-8">
          <div className="max-w-4xl mx-auto">
            <div className="text-center mb-12">
              <h1 className="font-heading text-3xl md:text-4xl font-bold text-foreground-900 mb-4">
                {t("footerTerms")}
              </h1>
            </div>

            <div className="space-y-8">
              <div className="p-6 md:p-8 rounded-2xl bg-background-100 border border-background-200/70">
                <h2 className="font-heading text-xl font-bold text-foreground-900 mb-4">Acceptance of Terms</h2>
                <p className="text-sm text-foreground-700 leading-relaxed">
                  By accessing and using this website, you accept and agree to be bound by these terms of service. If you do not agree with any part of these terms, you should discontinue use of this website immediately. These terms may be updated at any time without notice.
                </p>
              </div>

              <div className="p-6 md:p-8 rounded-2xl bg-background-100 border border-background-200/70">
                <h2 className="font-heading text-xl font-bold text-foreground-900 mb-4">Use of Content</h2>
                <p className="text-sm text-foreground-700 leading-relaxed mb-4">
                  All content on this website is provided for informational and educational purposes only. You may not reproduce, distribute, or modify any content without prior written permission. Content may be shared for personal, non-commercial purposes with proper attribution.
                </p>
                <p className="text-sm text-foreground-700 leading-relaxed">
                  This website contains links to third-party websites. We are not responsible for the content, accuracy, or availability of external websites. Following external links is at your own discretion and risk.
                </p>
              </div>

              <div className="p-6 md:p-8 rounded-2xl bg-background-100 border border-background-200/70">
                <h2 className="font-heading text-xl font-bold text-foreground-900 mb-4">No Warranties</h2>
                <p className="text-sm text-foreground-700 leading-relaxed">
                  This website and its content are provided "as is" without any warranties of any kind, either express or implied. We do not guarantee that the website will be available, error-free, or secure at all times. We do not warrant the accuracy, completeness, or reliability of any information provided.
                </p>
              </div>

              <div className="p-6 md:p-8 rounded-2xl bg-background-100 border border-background-200/70">
                <h2 className="font-heading text-xl font-bold text-foreground-900 mb-4">Limitation of Liability</h2>
                <p className="text-sm text-foreground-700 leading-relaxed">
                  In no event shall we be liable for any direct, indirect, incidental, special, or consequential damages arising from the use of or inability to use this website, even if we have been advised of the possibility of such damages. This includes damages resulting from any purchasing decisions made based on information found on this website.
                </p>
              </div>

              <div className="p-6 md:p-8 rounded-2xl bg-background-100 border border-background-200/70">
                <h2 className="font-heading text-xl font-bold text-foreground-900 mb-4">Governing Law</h2>
                <p className="text-sm text-foreground-700 leading-relaxed">
                  These terms shall be governed by and construed in accordance with applicable laws. Any disputes arising from these terms or the use of this website shall be subject to the exclusive jurisdiction of the competent courts.
                </p>
              </div>

              <div className="p-6 md:p-8 rounded-2xl bg-background-100 border border-background-200/70">
                <h2 className="font-heading text-xl font-bold text-foreground-900 mb-4">Changes to Terms</h2>
                <p className="text-sm text-foreground-700 leading-relaxed">
                  We reserve the right to modify these terms at any time. Changes will be effective immediately upon posting. Your continued use of this website after any changes constitutes acceptance of the modified terms.
                </p>
              </div>

              <div className="p-6 md:p-8 rounded-2xl bg-accent-50/50 border border-accent-200/50">
                <p className="text-sm text-foreground-700 leading-relaxed font-medium">
                  Last updated: August 25, 2026. If you have questions about these terms, please contact us.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
}